import { Dialog, Flex, Heading, Text, Button } from '@radix-ui/themes';
import React from 'react';

const ConfirmationDialogue = ({ Name, Type, Action, onCancel, onConfirm }) => {
    return (
        <Dialog.Root open>
            <Dialog.Content maxWidth="400px" style={{ padding: '20px', borderRadius: '8px' }}>
                
                {/* Heading with spacing and bold styling */}
                <Heading size="4" mb="3" weight="bold">
                    Confirm {Type}
                </Heading>

                {/* Confirmation message with proper spacing and styling */}
                <Text size="2" color="gray">
                    Are you sure you want to {Action}{' '}
                    <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                        {Name}
                    </span>?
                </Text>

                {/* Buttons aligned properly with spacing */}
                <Flex justify="end" gap="3" mt="4">
                    <Button variant="soft" onClick={onCancel} color="gray">Cancel</Button>
                    <Button color="red" onClick={onConfirm}>Confirm</Button>
                </Flex>

            </Dialog.Content>
        </Dialog.Root>
    );
};

export default ConfirmationDialogue;
